import {fetchCsConsultantWework} from '@api'

const namespaced = true

const state = {}

const getters = {}

const actions = {
  getCsConsultantWework: async (_, params) => {
    const res = await fetchCsConsultantWework({
      params,
    })

    return res.data.data
  },
}

const mutations = {}

const RepairStore = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}

export default RepairStore